/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the Screenshot interface.
 */
export function instanceOfScreenshot(value) {
    return true;
}
export function ScreenshotFromJSON(json) {
    return ScreenshotFromJSONTyped(json, false);
}
export function ScreenshotFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'caption': json['Caption'] == null ? undefined : json['Caption'],
        'url': json['Url'] == null ? undefined : json['Url'],
    };
}
export function ScreenshotToJSON(json) {
    return ScreenshotToJSONTyped(json, false);
}
export function ScreenshotToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Caption': value['caption'],
        'Url': value['url'],
    };
}
